import request from '@/utils/request'

export function wreathArrived(id) {
  return request({
    url: `/orders/${id}/wreath_arrived`,
    method: 'put'
  })
}
